import styled from "styled-components";

export const PopupContainer = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  background-color: white;
  border-radius: 13.489px;
  display: flex;
  flex-direction: column;

  > .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    > span {
      color: #121212;
      font-family: Pretendard;
      font-size: 23.606px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    > img {
      width: 17px;
      height: 17px;
      cursor: pointer;
    }
  }

  > .body {
  }
`;
export const ContentHeaderWrapper = styled.div`
  > span {
    color: #121212;
    font-family: Pretendard;
    font-size: 23.606px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  > img {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
  margin-top: 34.4px;
  margin-bottom: 18.3px;
  padding: 0 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const ContentBodyWrapper = styled.div`
  position: relative;
  left: 40px;
  width: calc(100% - 80px);
  display: flex;
  flex-direction: row;
`;

export const ContentBottomWrapper = styled.div`
  position: absolute;
  padding: 0 323px;
  display: flex;
  flex-direction: row;
  gap: 40px;
  bottom: 16px;

  > .button {
    cursor: pointer;
    width: 422.205px;
    height: 59.352px;
    border-radius: 30.35px;
    background: #969696;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 20.233px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .button.purple {
    background: var(--Purple-300, #6436e7);
  }
`;

export const Overlay = styled.div<{ $zIndex?: number }>`
  width: 100%;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: ${({ $zIndex }) => $zIndex ?? 99};
`;
